<template>
  <div class="cloud-native">
    <Panel>
      <template slot="panel">
        <div class="flex cloud-main">
          <div class="cloud-img">
            <img class="margin-bottom-15 cloud-img" src="@/assets/img/cloud.png">
          </div>
          <div class="flex-item font-20 margin-top-25 cloud-title">
            <span class="weight-bold"><span class="text-red">{{$root.language.homeRow11}}</span>
              {{$root.language.homeRow12}}
            </span>{{$root.language.homeRow13}}
            {{$root.language.homeRow14}}
          </div>
        </div>

        <div class="flex cloud-main" :style="backgroundImg">
          <div class="flex-item padding-z-40 bg-white height-350 cloud-engineering">
            <div class="flex">
              <img src="@/assets/img/digital.png" width="148" height="201" alt="">
              <div class="flex-item">
                <div class="title font-26 weight-bold">{{$root.language.engineering}}</div>
                <ul class="font-20 margin-left-50">
                  <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.navigator}}</span></li>
                  <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.pdm}}</span></li>
                  <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.ppm}}</span></li>
                  <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.npi}}</span></li>
                </ul>
                <SkewButton class="weight-bold font-16 margin-left-25 text-center" width="178" :text="$root.language.homeRow15" @click="jumpProduct"></SkewButton>
              </div>
            </div>
          </div>

          <div class="flex-item padding-z-40 bg-white height-350 cloud-factory">
            <div class="flex">
              <img src="@/assets/img/factory.png" width="170" height="207" alt="">
              <div class="flex-item">
                <div class="title font-26 weight-bold">{{$root.language.factory}}</div>
                <ul class="font-20 margin-left-50">
                  <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.pqm}}</span></li>
                  <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.deviceMate}}</span></li>
                  <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.productionLineEngine}}</span></li>
                </ul>
                <SkewButton class="weight-bold font-16 margin-left-25 text-center" width="178" :text="$root.language.homeRow15" @click="jumpProduct"></SkewButton>
              </div>
            </div>
          </div>
        </div>
        <!-- <a-row :gutter="[60,8]"> -->
          <!-- <a-col :lg="{ span: 4 }" :md="{span: 6}"> -->
            <!-- <img class="margin-bottom-15 cloud-img" src="@/assets/img/cloud.png"> -->
          <!-- </a-col> -->
          <!-- <a-col :lg="{ span: 18 }" :md="{span: 14}"> -->
            <!-- <div class="flex-item font-20 margin-top-25 cloud-title"> -->
              <!-- <span class="weight-bold"><span class="text-red">{{$root.language.homeRow11}}</span> -->
                <!-- {{$root.language.homeRow12}} -->
              <!-- </span>{{$root.language.homeRow13}} -->
              <!-- {{$root.language.homeRow14}} -->
            <!-- </div> -->
          <!-- </a-col> -->
        <!-- </a-row> -->
        <!-- <a-row :gutter="[100,8]" :style="backgroundImg"> -->
          <!-- <a-col :lg="{ span: 12 }"> -->
            <!-- <div class="flex bg-white padding-z-40 height-350 cloud-engineering"> -->
              <!-- <img src="@/assets/img/digital.png" width="148" height="201" alt=""> -->
              <!-- <div class="flex-item"> -->
                <!-- <div class="title font-26 weight-bold">{{$root.language.engineering}}</div> -->
                <!-- <ul class="font-20 margin-left-50"> -->
                  <!-- <li class="padding-y-4"> -->
                    <!-- <a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.navigator}}</span> -->
                  <!-- </li> -->
                  <!-- <li class="padding-y-4"> -->
                    <!-- <a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.pdm}}</span></li> -->
                  <!-- <li class="padding-y-4"> -->
                    <!-- <a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.ppm}}</span></li> -->
                  <!-- <li class="padding-y-4"> -->
                    <!-- <a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.mpm}}</span></li> -->
                  <!-- <li class="padding-y-4"> -->
                    <!-- <a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.npi}}</span></li> -->
                <!-- </ul> -->
                <!-- <SkewButton class="weight-bold font-16 margin-left-50 text-center" width="178" -->
                  <!-- :text="$root.language.homeRow15" @click="jumpProduct"></SkewButton> -->
              <!-- </div> -->
            <!-- </div> -->
          <!-- </a-col> -->
          <!-- <a-col :lg="{ span: 12 }"> -->
            <!-- <div class="flex bg-white padding-z-40 height-350 cloud-factory"> -->
              <!-- <img src="@/assets/img/factory.png" width="170" height="207" alt=""> -->
              <!-- <div class="flex-item"> -->
                <!-- <div class="title font-26 weight-bold">{{$root.language.factory}}</div> -->
                <!-- <ul class="font-20 margin-left-15"> -->
                  <!-- <li class="text-gray padding-y-4"> -->
                    <!-- <a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.pqm}}</span></li> -->
                  <!-- <li class="text-gray padding-y-4"> -->
                    <!-- <a-icon type="caret-right" /><span -->
                      <!-- class="weight-bold text-gray">{{$root.language.deviceMate}}</span></li> -->
                  <!-- <li class="text-gray padding-y-4"> -->
                    <!-- <a-icon type="caret-right" /><span -->
                      <!-- class="weight-bold text-gray">{{$root.language.productionLineEngine}}</span></li> -->
                <!-- </ul> -->
                <!-- <SkewButton class="weight-bold font-16 margin-left-25 text-center" width="178" -->
                  <!-- :text="$root.language.homeRow15" @click="jumpProduct"></SkewButton> -->
              <!-- </div> -->
            <!-- </div> -->
          <!-- </a-col> -->
        <!-- </a-row> -->
      </template>
    </Panel>
  </div>
</template>

<script>
import Panel from '@/components/panel'
import SkewButton from '@/components/button-skew'
export default {
  components: {
    Panel,
    SkewButton
  },

  data () {
    return {
      backgroundImg: {
        backgroundImage: `url(${require('@/assets/img/mul-line.png')})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 30%',
        backgroundSize: '154px 100px'
      }
    }
  },

  methods: {
    jumpProduct () {
      this.$router.push({
        path: '/products'
      })
    }
  }
}

</script>

<style scoped>
  .cloud-native {
    padding: 65px 0;
    background-color: #e9e9e9;
    color: #333;
  }

  .height-350 {
    height: 350px;
  }

  .margin-right-50 {
    margin-right: 50px;
  }

  .margin-left-50 {
    margin-left: 50px;
  }

  .margin-left-25 {
    margin-left: 25px;
  }

  .margin-top-25 {
    margin-top: 25px;
  }

  .padding-y-4 {
    padding: 4px 0;
  }

  .padding-z-40 {
    padding: 40px;
  }

  .text-gray {
    color: #737373;
  }

  .cloud-img {
    width: 11rem;
    transition: all 1s;
    margin-right: 50px;
  }

  .cloud-engineering {
    margin-right: 100px
  }
  /* .cloud-factory { */
    /* margin-left: 50px; */
  /* } */
  @media (max-width: 578px) {
    .cloud-native {
      padding: 15px 0;
    }
    .cloud-img {
      width: 130px;
      margin-right: 0;
    }
    .cloud-title {
      padding: 0 10px;
      margin-top: 0;
    }

    .cloud-engineering {
      margin-right: 0;
    }

    .cloud-factory {
      margin-top: 10px;
    }

    .cloud-engineering,
    .cloud-factory {
      padding: 10px 10px 0 10px;
    }

    .cloud-main {
      display: block;
    }

    .cloud-factory img {
      width: 145px;
    }
    .margin-left-50 {
      margin-left: 0;
    }
  }
</style>
